import { useAuth } from 'context/auth';
import CrmHubspotIcon from 'crono-fe-common/icons/Icon-CRM-Hubspot';
import CrmPipedriveIcon from 'crono-fe-common/icons/Icon-CRM-Pipedrive';
import CrmSalesforceIcon from 'crono-fe-common/icons/Icon-CRM-Salesforce';
import CrmChartMogulIcon from 'crono-fe-common/icons/Icon-CRM-ChartMogul';
import CrmAttioIcon from 'crono-fe-common/icons/Icon-CRM-Attio';
import CrmZohoIcon from 'crono-fe-common/icons/Icon-CRM-Zoho';
import CrmDynamicsIcon from 'crono-fe-common/icons/Icon-CRM-Dynamics';
import IntegrationType from 'crono-fe-common/types/enums/integrationType';
import IProps from 'crono-fe-common/icons/interface';

const CrmIcon = (props: IProps) => {
  const { user } = useAuth();
  const integrationType = user?.company?.integrationType;

  switch (integrationType) {
    case IntegrationType.HUBSPOT:
      return <CrmHubspotIcon {...props} />;

    case IntegrationType.PIPEDRIVE:
      return <CrmPipedriveIcon {...props} />;

    case IntegrationType.SALESFORCE:
      return <CrmSalesforceIcon {...props} />;

    case IntegrationType.CHART_MOGUL:
      return <CrmChartMogulIcon {...props} />;

    case IntegrationType.ATTIO:
      return <CrmAttioIcon {...props} />;

    case IntegrationType.ZOHO:
      return <CrmZohoIcon {...props} />;

    case IntegrationType.DYNAMICS:
      return <CrmDynamicsIcon {...props} />;

    default:
      return null;
  }
};

export default CrmIcon;
